<div class="row no-gutters" style="margin-right: 1.875rem">
  <div mat-dialog-title class="col d-flex align-items-center">
    Expired Vaccine(s)
  </div>
  <button mat-dialog-close class="col-auto btn-close-dialog">
    <fa-icon [icon]="faTimes" size="lg"></fa-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="camp-details-section-container">
    <div class="modal-body">
      <div class="modal-text">
        <div>
          One or more dogs for this reservation request have expired vaccination
          records.
        </div>
        <div>
          You must submit updated vaccination records before the reservation
          occurs.
        </div>
      </div>
      <div
        *ngFor="let pet of petList; let isLastChild = last"
        [ngClass]="{ 'last-child': isLastChild }"
      >
        <app-reservation-summary-tile
          [petInfo]="pet"
        ></app-reservation-summary-tile>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn-block" (click)="close()">
        Close
      </button>
    </div>
  </div>
</mat-dialog-content>
